import React, { memo, useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import GlassCard from '../card/GlassCard';
import { coqCols, coqOptions, yearStackOptions } from 'services/glass-management/coq';
import SLAChart from '../SLAChart';
import { Col, Row, Spinner, Tab, Tabs } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import { openModal } from 'slices/glassDashboard/glassDataModalSlice';
import FailureUnitGauge from './FailureUnitGauge';
import FailureCostGauge from './FailureCostGauge';

const target = 1.5;

const CoQ = () => {
    const dispatch = useDispatch();
    const { data, loading, error } = useSelector(s => s.coq);
    const { data: coqYearData, loading: coqYearLoading, error: coqYearError } = useSelector(s => s.coqYear);
    const [options, setOptions] = useState(coqOptions);
    const [yearOptions, setYearOptions] = useState(yearStackOptions);

    if (error || coqYearError)
        toast.error('Something went wrong!', error || coqYearError);

    const keys = {
        '30 Day': 'ThirtyDays',
        '60 Day': 'SixtyDays',
        '120 Day': 'OneTwentyDays',
        '12 Month': 'OneYear',
        '12+ Month': 'OneYearPlus'
    };

    const formatTableData = useCallback(tableData =>
        tableData?.map(x => {
            return {
                ...x,
                OriginalCost: '£' + x?.OriginalCost?.toFixed(2),
                RecordedDate: dayjs(x?.RecordedDate)?.format('DD-MM-YYYY'),
                ReplacementDeliveryDate: dayjs(x?.ReplacementDeliveryDate)?.format('DD-MM-YYYY'),
            }
        }), []);

    const onChartClick = useCallback((e) => {
        if (e?.name) {
            const key = keys[e?.name];
            const tableData = formatTableData(data?.graph[key]);

            dispatch(openModal({
                modalData: tableData,
                modalLoading: false,
                modalShow: true,
                modalTitle: 'CoQ - ' + e?.name,
                tableCols: coqCols,
            }));
        }
    }, [dispatch, data]);

    const showAllData = useCallback(() => {
        console.log(Object.keys(data?.graph).flatMap(x => data?.graph[x]))
        dispatch(openModal({
            modalData: formatTableData(Object.keys(data?.graph).flatMap(x => data?.graph[x])),
            modalLoading: false,
            modalShow: true,
            modalTitle: 'All CoQ',
            tableCols: coqCols,
        }))
    }, [data]);

    useEffect(() => {
        setOptions(
            {
                ...coqOptions,
                series: [
                    { ...coqOptions.series[0], data: data?.graph?.Qty },
                    { ...coqOptions.series[1], data: data?.graph?.Cost },
                    { ...coqOptions.series[2], data: data?.graph?.Percentage },
                ]
            }
        );
    }, [data]);
    useEffect(() => {
        let xaxis = [];
        let series = [...yearStackOptions.series];
        const yearData = coqYearData?.yearSummary;

        if (yearData?.length > 0) {
            for (let i = 0; i < yearData?.length; i++) {
                const item = yearData[i] || {};
                series[0].data.push(item?.Remakes?.Qty);
                series[1].data.push(item?.ThirtyDays?.Qty);
                series[2].data.push(item?.SixtyDays?.Qty);
                series[3].data.push(item?.OneTwentyDays?.Qty);
                series[4].data.push(item?.OneYear?.Qty);
                series[5].data.push(item?.OneYearPlus?.Qty);
                xaxis.push(dayjs(`${item.Year}-${item.Month}-01`).format('MMM YYYY'));
            }
        }
        setYearOptions({
            ...yearStackOptions,
            xAxis: {
                type: 'category',
                data: xaxis
            },
            series
        })
    }, [coqYearData]);

    return (
        <GlassCard height={450} md={12} lg={12} sm={12} xl={12} title="CoQ" heroValue={{ func: showAllData }} loading={loading}>
            <Row>
                <Col sm={8}>
                    <Tabs defaultActiveKey="bathtub" id="coq-tabs" className='border-bottom-0'>
                        <Tab eventKey="bathtub" title="Bathtub">
                            <SLAChart loading={loading} options={options} onClick={onChartClick} height='350px' />
                        </Tab>
                        <Tab eventKey="year" title="Year Stack">
                            <SLAChart loading={coqYearLoading} options={yearOptions} onClick={() => null} height='350px' />
                        </Tab>
                    </Tabs>
                </Col>
                <Col sm={4} className='p-3'>
                    {loading ? <div className='text-center'><Spinner variant='primary' /></div> :
                        <>
                            <Row><Col><b>Target:</b><span className='text-success fw-bolder'> {target}</span></Col></Row>
                            <Row><FailureUnitGauge data={data?.table || {}} target={target} /></Row>
                            <Row><FailureCostGauge data={data?.table || {}} /></Row>
                        </>
                    }
                </Col>
            </Row>
        </GlassCard>
    );
}

export default memo(CoQ);